'use client'
import { cn } from '@/lib/utils'
import Link from 'next/link'
import { useParams } from 'next/navigation'
import { allVariants, defaultButtonStyles } from '../button'

type LinkProps = {
   children: React.ReactNode
   className?: string
   variant?: 'primary' | 'secondary' | 'primary_outline' | 'bgthird' | 'text'
   href: string
}

export const DMLink = ({
   children,
   className = '',
   variant = 'text',
   href = '/',
}: LinkProps) => {
   const { locale } = useParams()
   const currentVariant = `${defaultButtonStyles} ${allVariants[variant]}`

   return (
      <Link
         href={`/${locale}${href}`}
         className={cn(currentVariant, className)}
      >
         {children}
      </Link>
   )
}
